// Opens, closes or toggles the site search modal (components/SearchModal.jsx)
// from anywhere. The header's search icons toggle it; the modal subscribes
// once on mount and receives the action. Same shape as brandNavSignal: no
// context, no prop drilling.
const handlers = new Set();

function emit(action) {
  for (const handler of handlers) handler(action);
}

export function openSearchModal() {
  emit("open");
}

export function closeSearchModal() {
  emit("close");
}

export function toggleSearchModal() {
  emit("toggle");
}

// The same overlay holding the showcase brands in place of the search bar
// (SearchModal's brands mode). The desktop header's SHOWCASE toggles it.
export function toggleShowcaseModal() {
  emit("brands");
}

export function onSearchModal(handler) {
  handlers.add(handler);
  return () => handlers.delete(handler);
}

// Whether the modal is on screen, published by SearchModal itself so the
// requests above (which say what was ASKED) and the state (what IS) cannot
// disagree. The phone header reads it to turn its search icon into the close
// control while the search is up. Same external-store shape as
// utils/displayedRoute, for useSyncExternalStore.
let shown = false;
const listeners = new Set();

export function publishSearchModalShown(next) {
  if (next === shown) return;
  shown = next;
  for (const listener of listeners) listener();
}

export function getSearchModalShown() {
  return shown;
}

export function subscribeSearchModalShown(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

// Which face the modal is showing, "search" (the bar) or "brands" (the
// showcase list), published by SearchModal the same way and to the same
// listeners, so one subscription covers both. The desktop header lights
// SHOWCASE while the showcase list is up.
let mode = "search";

export function publishSearchModalMode(next) {
  if (next === mode) return;
  mode = next;
  for (const listener of listeners) listener();
}

export function getSearchModalMode() {
  return mode;
}
